const API_BASE = 'https://honeydew-mouse-298884.hostingersite.com/api/subscriptions';

function authHeaders() {
  const token = localStorage.getItem('token');
  return {
    'Content-Type': 'application/json',
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };
}

async function call(path, options = {}) {
  const res = await fetch(`${API_BASE}${path}`, { ...options, headers: authHeaders() });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(data.message || 'Something went wrong. Please try again.');
  }
  return data;
}

// GET /api/subscriptions/me
export async function getMySubscription() {
  return (await call('/me')).subscription;
}

// GET /api/subscriptions/terms
export async function getPaymentTerms(planType) {
  return (await call(`/terms?planType=${encodeURIComponent(planType)}`)).terms;
}

// POST /api/subscriptions/checkout
export function startCheckout(planType) {
  return call('/checkout', { method: 'POST', body: JSON.stringify({ planType }) });
}

// POST /api/subscriptions/verify
export function verifyPayment(payload) {
  return call('/verify', { method: 'POST', body: JSON.stringify(payload) });
}

// PUT /api/subscriptions/cancel
export async function cancelSubscription(atCycleEnd = true) {
  return (await call('/cancel', { method: 'PUT', body: JSON.stringify({ atCycleEnd }) })).subscription;
}

// PUT /api/subscriptions/auto-renewal
export async function updateAutoRenewal(autoRenewal) {
  return (await call('/auto-renewal', { method: 'PUT', body: JSON.stringify({ autoRenewal }) })).subscription;
}